import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from '../../util/reactIntl';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError, IconThumbDown } from '../../components';

import css from './FieldReviewRating.css';

class FieldReviewRatingComponent extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.input.onChange(event.target.value);
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {
      rootClassName,
      className,
      inputRootClass,
      customErrorText,
      id,
      intl,
      label,
      input,
      meta,
      ...rest
    } = this.props;
    /* eslint-enable no-unused-vars */

    const { touched, error } = meta;
    const errorText = customErrorText || error;
    const fieldMeta = { touched, error: errorText };

    const { value, ...restInputProps } = input;
    const inputProps = { ...restInputProps, type: 'radio', name: 'rating', ...rest };

    const classes = classNames(rootClassName || css.root, className);

    const createThumbRating = () => {
      const thumbUpInputId = `${id}.thumbUp`;
      const thumbDownInputId = `${id}.thumbDown`;

      return (
        <>
          <input
            key={thumbDownInputId}
            id={thumbDownInputId}
            className={css.rateInput}
            value={1}
            checked={value === `1`}
            {...inputProps}
          />
          <label
            key={`label.${thumbDownInputId}`}
            className={css.label}
            htmlFor={thumbDownInputId}
            title={intl.formatMessage({ id: `FieldReviewRating.thumbDown` })}
          >
            <IconThumbDown className={css.thumb} />
          </label>
          <input
            key={thumbUpInputId}
            id={thumbUpInputId}
            className={css.rateInput}
            value={5}
            checked={value === `5`}
            {...inputProps}
          />
          <label
            key={`label.${thumbUpInputId}`}
            className={css.label}
            htmlFor={thumbUpInputId}
            title={intl.formatMessage({ id: `FieldReviewRating.thumbUp` })}
          >
            <IconThumbDown className={classNames(css.thumb, css.thumbUp)} />
          </label>
        </>
      );
    };

    return (
      <div className={classes}>
        <fieldset
          className={css.ratingFieldSet}
          ref={c => {
            this.ratingFieldSet = c;
          }}
        >
          {label ? <legend>{label}</legend> : null}
          <div className={css.rating}>{createThumbRating()}</div>
        </fieldset>
        <ValidationError fieldMeta={fieldMeta} />
      </div>
    );
  }
}

FieldReviewRatingComponent.defaultProps = {
  rootClassName: null,
  className: null,
  customErrorText: null,
  label: null,
};

const { string, shape, func, object } = PropTypes;

FieldReviewRatingComponent.propTypes = {
  rootClassName: string,
  className: string,
  id: string.isRequired,
  label: string,

  // Error message that can be manually passed to input field,
  // overrides default validation message
  customErrorText: string,

  // Generated by final-form's Field component
  input: shape({
    onChange: func.isRequired,
  }).isRequired,
  meta: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const FieldReviewRating = props => {
  return <Field component={FieldReviewRatingComponent} {...props} />;
};

export default injectIntl(FieldReviewRating);
